import { Head } from "@/components/head";
import { DrugPaymentPage } from "@/features/drug-payment/components/drug-payment-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/drug-payment/$referralId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { referralId } = Route.useParams();

  return (
    <>
      <Head title="Drug Payment" />
      <DrugPaymentPage referralId={referralId} />
    </>
  );
}
